import { makeStyles } from '@material-ui/core';

import WIDE_SINGLE_COLUMN_CONTENT_WIDTH from 'pages/wideSingleColumnLayout';

export default makeStyles(theme => ({
  header: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(3, 0),
    marginBottom: theme.spacing(3),
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gridGap: theme.spacing(2),
  },
  stepperButton: {
    minWidth: '100px',
  },
  stepperRoot: {
    background: 'none',
  },
  stepperDots: {
    display: 'none',
  },
  description: {
    margin: theme.spacing(2, 0),
  },
  answer: {
    margin: theme.spacing(1, 0),
  },
  accordionTile: {
    marginBottom: theme.spacing(2),
    // @ts-ignore
    border: `thin solid ${theme.palette.secondary[100]}`,
    // @ts-ignore
    borderRadius: theme.shape.borderRadiusLarge,
    padding: theme.spacing(0.75, 2),
  },
  recommendedGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '15px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  recommendedGuides: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '15px',
    marginBottom: theme.spacing(3),
  },
  startTest: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  metadataPanel: {
    display: 'grid',
    gridGap: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
  },
  metadataFields: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gridGap: theme.spacing(2),
  },
  metadataActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  resultContent: {
    width: '100%',
    maxWidth: WIDE_SINGLE_COLUMN_CONTENT_WIDTH,
    margin: '0 auto',
  },
  resultMeta: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1, 3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  resultQuestion: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));
